"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGamepad = exports.GamepadProvider = void 0;
var GamepadProvider_1 = __importDefault(require("./GamepadProvider"));
exports.GamepadProvider = GamepadProvider_1.default;
var useGamepad_1 = __importDefault(require("./useGamepad"));
exports.useGamepad = useGamepad_1.default;
